<style>
  .danger {
    color: #f44336;
  }
</style>

<div class="h-screen w-full flex items-center justify-center text-center">
  <div class="flex flex-col items-center gap-6 w-full">
    <img
      src="assets/images/techspert_logo.svg"
      class="mx-auto max-h-[240px] max-w-full w-auto h-auto"
      alt="techspert.io logo - Loading... Please wait"
    />
    <div class="flex flex-col gap-4">
      <h1>Not Authorised</h1>
      <h2 class="danger">{{ errors$ | async }}</h2>

      <div>
        <button matButton="filled" color="accent" (click)="logout()">Logout</button>
      </div>
    </div>
  </div>
</div>
